import React from 'react';
import PropTypes from 'prop-types';
import { RequestedShippingService } from '../../../../../fulfillment-planner/requested-shipping-service';
import { RequestedServiceLabel } from '../../../../../fulfillment-planner/requested-shipping-service/label';

import style from './style.module.less';

export const RequestedService = ({ fulfillmentPlanId }) => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <RequestedServiceLabel />
      </div>
      <div className={style['requested-service']}>
        <RequestedShippingService fulfillmentPlanId={fulfillmentPlanId} />
      </div>
      <div />
    </React.Fragment>
  );
};

RequestedService.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
